<template>
	<v-content id="main">
		<v-container
			fluid
			fill-height
			class="main--text">
      <TeacherUnLoggedInAppToolBar/>
			<v-row
				justify="center"
				fill-height>
				<v-col md="6">
					<h1 class="display-4 white-text"></h1>
				</v-col>
				<v-col md="6">
					<v-row>
						<v-col>
							<TopLogin/>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>
		<!-- <TeacherStart
			class="main--text"/> -->
		<teacher-footer/>
	</v-content>
</template>


<script>
import TopLogin from '@/components/organisms/teacher/TopLogin.vue'
import TeacherUnLoggedInAppToolBar from '@/components/organisms/teacher/TeacherUnLoggedInAppToolBar.vue'
import TeacherStart from '@/components/organisms/teacher/TeacherStart.vue'
import TeacherFooter from '@/components/organisms/teacher/TeacherFooter.vue'

export default {
  name: 'TeacherTop',
  components: {
    'TopLogin': TopLogin,
    'TeacherUnLoggedInAppToolBar': TeacherUnLoggedInAppToolBar,
    'TeacherStart': TeacherStart,
    'TeacherFooter': TeacherFooter
  }
}
</script>

<style scoped>
#main {
  background-image: url('../../../assets/img/teachers_top_background.jpg');
  background-size: cover;
  height: 1000px;
}

.white-text {
  color: white;
}
</style>